import { certificateConstants } from '../../constants'

const initialState = {
  reqInfo: '',
  retUrl: '',
  resultInfo: '',
  // V4 추가 필드 (V2/V3에서는 미사용)
  cryptoTokenId: '',
  integrityValue: '',
  verSion: '',
  standardWindowUrl: '',
}

export default function certificate(state = initialState, action) {
  switch (action.type) {
    /*********
       kmc
    **********/

    case certificateConstants.CERT_SUCCESS: {
      // 백엔드가 실패인데도 HTTP 200 + payload 없이 내려주는 경우 방어(크래시 방지)
      const payload = action.response?.data?.payload
      if (!payload) {
        console.error('CERT_SUCCESS 이지만 payload 없음', action.response?.data)
        return { ...state }
      }
      return {
        ...state,
        reqInfo: payload['reqInfo'],
        retUrl: payload['retUrl'],
        // V4 payload 필드(V2/V3에는 없으므로 없으면 '' 유지)
        cryptoTokenId: payload['crypto_token_id'] || '',
        integrityValue: payload['integrity_value'] || '',
        verSion: payload['verSion'] || '',
        standardWindowUrl: payload['standardWindowUrl'] || '',
      }
    }

    case certificateConstants.CERT_FAILURE:
      return {}

    case certificateConstants.CERT_RESULT_SUCCESS:
      console.log('본인인증 결과 정보', action.response?.data?.payload)
      return {
        ...state,
        resultInfo: action.response?.data?.payload || {},
      }

    case certificateConstants.CERT_RESULT_FAILURE:
      return {}

    case certificateConstants.CERT_SET_INITIAL_STATE:
      return { reqInfo: '', retUrl: '', resultInfo: '', cryptoTokenId: '', integrityValue: '', verSion: '', standardWindowUrl: '' }

    default:
      return state
  }
}
